import React, { useContext } from 'react';
import { useMutation } from 'react-apollo-hooks';
import { changeMembershipPermissions, accountMembersQuery } from '../../../../queries/account';
import {
  ChangeMembershipPermissions,
  ChangeMembershipPermissionsVariables
} from '../../../../queries/__generated__/ChangeMembershipPermissions';
import { Switch } from '../../../forms';
import { AccountContext } from '../../../../context/account';

interface AdminSwitch {
  member: {
    id: string;
    roleType: string; //'MEMBER' | 'ADMIN';
  };
  disabled?: boolean;
}

const AdminSwitch: React.FC<AdminSwitch> = ({ member, disabled }) => {
  const { selectedAccountId } = useContext(AccountContext);
  const toggleAdminRights = useMutation<
    ChangeMembershipPermissions,
    ChangeMembershipPermissionsVariables
  >(changeMembershipPermissions, {
    variables: {
      input: {
        memberId: member.id,
        roleType: member.roleType === 'ADMIN' ? 'MEMBER' : 'ADMIN'
      }
    },
    refetchQueries: [
      {
        query: accountMembersQuery,
        variables: { input: { accountId: selectedAccountId } }
      }
    ]
  });

  return (
    <Switch
      active={member.roleType.toUpperCase() === 'ADMIN'}
      onClick={toggleAdminRights}
      disabled={disabled}
    />
  );
};

export default AdminSwitch;
